import React, { useEffect } from 'react';

import Header from '../../layout/Header.jsx';
import ListArticles from '../../lists/ListArticles.jsx';
import FormTopTags from '../../forms/FormTopTags.jsx';
import useHttpStatus from '~/commons/hooks/useHttpStatus';
import PageHttp from '~/commons/components/PageHttp.jsx';

const PageArticles = () => {
  const [res, req] = useHttpStatus();

  useEffect(() => {
    req({ url: '/api/quiz/top-tags' });
  }, []);

  return (
    <div>
      <Header>Articles</Header>
      <PageHttp res={res}>
        {(doc) => (
          <div className="card p-4 mb-4">
            <FormTopTags topTags={doc} />
          </div>
        )}
      </PageHttp>
      <ListArticles />
    </div>
  );
};

export default PageArticles;
